export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 4